export default function ValidIfIsWithinOperatingPaymentPeriod() {
  const minPossibleHour = 8;
  const maxPossibleHour = 23;
  const maxMinutesInMaxPossibleHour = 50;

  const configFormatDate = {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'America/Sao_Paulo',
    hour12: false,
  };

  const localDate = new Date();

  const currentDateInBrazil = new Intl.DateTimeFormat('pt-BR', {
    ...configFormatDate,
  }).format(localDate);

  const [currentHourInBrazil, currentMinutesInBrazil] =
    currentDateInBrazil.split(':');

  let isWithinOperatingPaymentPeriod = false;

  if (
    (currentHourInBrazil == maxPossibleHour &&
      currentMinutesInBrazil < maxMinutesInMaxPossibleHour) ||
    (currentHourInBrazil >= minPossibleHour &&
      currentHourInBrazil < maxPossibleHour)
  ) {
    isWithinOperatingPaymentPeriod = true;
  }

  return isWithinOperatingPaymentPeriod;
}
